/**
 * Created by hp on 2017/8/30.
 */
import React from 'react'
import {browserHistory, Route, Router, IndexRoute, useRouterHistory} from 'react-router'
import { createHistory } from 'history';
import Root from './Root'

import MainPage from './pages/MainPage'
import LecturePageContainer from './pages/LecturePageContainer'
import ClassroomPage from './pages/ClassroomPage'
import LiveroomPage from './pages/LiveroomPage'
import ChannelPage from './pages/ChannelPage'
import ChannelEditPage from './pages/ChannelEdit/ChannelEditPage'
import ChannelEditTitlePage from './pages/ChannelEdit/ChannelEditTitlePage'
import ChannelEditCoverPage from './pages/ChannelEdit/ChannelEditCoverPage'
import ChannelEditDescPage from './pages/ChannelEdit/ChannelEditDescPage'
import ChannelEditPayPage from './pages/ChannelEdit/ChannelEditPayPage'
import ChannelEditPriorityPage from './pages/ChannelEdit/ChannelEditPriorityPage'
import ChannelShareRankPage from './pages/ChannelShareRankPage'
import QuestionPage from './pages/QuestionPage'
import QuestionCategory from './pages/QuestionCategory'
import QuestionCategoryDetail from './pages/QuestionCategoryDetail'
import BoughtPage from './pages/BoughtPage/BoughtPage'
import LectureErrorPage from './pages/LectureErrorPage'
import LectureShareRankPage from './pages/LectureShareRankPage'
import LectureEditPage from './pages/LectureEdit/LectureEditPage'
import LectureEditPayPage from './pages/LectureEdit/LectureEditPayPage'
import LectureEditTimePage from './pages/LectureEdit/LectureEditTimePage'
import LectureEditChannelPage from './pages/LectureEdit/LectureEditChannelPage'
import LectureEditModePage from './pages/LectureEdit/LectureEditModePage'
import LectureEditRewardPage from './pages/LectureEdit/LectureEditRewardPage'
import LectureEditLimitPage from './pages/LectureEdit/LectureEditLimitPage'
import LectureEditTitlePage from './pages/LectureEdit/LectureEditTitlePage'
import LectureEditCoverPage from './pages/LectureEdit/LectureEditCoverPage'
import LectureEditDescPage from './pages/LectureEdit/LectureEditDescPage'
import LectureEditPriorityPage from './pages/LectureEdit/LectureEditPriorityPage'
import LectureEditCategoryPage from './pages/LectureEdit/LectureEditCategoryPage'
import DataCenterPayListPage from './pages/DataCenterPayListPage'
import TransactionRecordPage from './pages/TransactionRecordPage'
import ShareCardPage from './pages/ShareCardPage'
import FavouriteRecordPage from './pages/FavouriteRecordPage'
import GiftCardDetailPage from './pages/GiftCardDetailPage'
import GiftCardSharePage from './pages/GiftCardSharePage'
import GiftCardAcceptPage from './pages/GiftCardAcceptPage'
import JoinLectureListPage from './pages/JoinLectureListPage'
import FollowRecordPage from './pages/FollowRecordPage'
import BestSubjectPage from './pages/BestSubjectPage/BestSubjectPage'
import FreeLecturePage from './pages/FreeLecturePage'
import FreeLectureNewPage from './pages/FreeLectureNewPage'
import FreeLectureCard from './pages/FreeLectureCard'
import WalletPage from './pages/WalletPageNew'
import ListenerManage from './pages/ListenerManage'
import SearchPage from './pages/SearchPage'
import SearchDetailPage from './pages/SearchDetailPage'
import LiveroomSettingVipPage from './pages/liveroomLecturer/VipPage'
import LiveroomSettingLecturesPage from './pages/liveroomLecturer/LecturesPage'
import liveroomlecturerBan from './pages/liveroomLecturer/LiveroomLecturerBan'
import liverooomlectureManage from './pages/liveroomLecturer/LiveroomLecturerManage'
import LiveroomLecturerManagerInvitePage from './pages/liveroomLecturer/LiveroomLecturerManagerInvitePage'
import LiveroomLecturerAcceptInvitePage from './pages/liveroomLecturer/LiveroomLecturerAcceptInvitePage'
import liveroomlectuerrMain from './pages/liveroomLecturer/MainPage'
import LiveroomSettingProfilePage from './pages/liveroomLecturer/ProfilePage'
import LiveroomFollowersPage from './pages/LiveroomFollowersPage'
import RelaySettingPage from './pages/RelaySettingPage'
import RelaySettingListPage from './pages/RelaySettingListPage'
import RelaySettingSharePage from './pages/RelaySettingSharePage'
import RelaySettingAcceptPage from './pages/RelaySettingAcceptPage'
import RelaysPage from './pages/RelaysPage'
import RelayConfirmPage from './pages/RelayConfirmPage'
import WalletDetailPage from './pages/WalletDetailPage'
import CouponListPage from './pages/CouponListPage'
import CouponViewPage from './pages/CouponViewPage'
import CouponSharePage from './pages/CouponSharePage'
import LecturerInvitePage from './pages/lecutrerInvite/LecturerInvitePage'
import LecturerInviteCardPage from './pages/lecutrerInvite/LecturerInviteCard'
import ComplainCategoryPage from './pages/ComplainCategoryPage'
import ComplainReasonPage from './pages/ComplainReasonPage'
import BoardGeneralPage from './pages/BoardGeneralPage'
import LiveroomVerifyPage from './pages/LiveroomVerifyPage'
import MessagePage from './pages/MessagePage'
import MessageInfoPage from './pages/MessageInfoPage'
import MessageChatPage from './pages/MessageChatPage'
import WithdrawApplyPage from './pages/WithdrawApplyPage'
import WithdrawApplyRecordPage from './pages/WithdrawApplyRecordPage'
import CustomerServicePage from './pages/CustomerServicePage'
import PaySuccessPage from './pages/PaySuccess'
import LiveroomVipPage from './pages/LiveroomVipPage'
import LiveroomVipList from './pages/liveroomLecturer/LiveroomVipList'
import LectureRewardListPage from './pages/LectureRewardListPage'
import ProfileEditPage from './pages/ProfileEditPage'
import PhoneEditPage from './pages/PhoneEditPage'
import ConnectAppPage from './pages/connectApp/ConnectAppPage'
import LectureCreateNewPage from './pages/lectureCreate/LectureCreateNewPage'
import LectureCreateFormPage from './pages/lectureCreate/LectureCreateFormPage'
import ChannelCreatePage from './pages/channelCreate/ChannelCreatePage'
import LiveroomCreatePage from './pages/liveroomCreate/LiveroomCreatePage'
import LiveroomCreateGuidePage from './pages/liveroomCreate/LiveroomCreateGuidePage'
import MyNewWeiKePage from './pages/mywkPage/MyNewWeiKePage'
import AccountPage from './pages/AccountPage/AccountPage'
import AccountSettingPage from './pages/AccountPage/AccountSettingPage'
import GiftReceiveSuccessPage from './pages/GiftReceiveSuccessPage'
import FeedbackPage from './pages/feedback/FeedbackPage'
import MyCouponListPage from './pages/MyCouponListPage'
import ScheduleCalendarPage from './pages/schedule/ScheduleCalendarPage'
import ScheduleSigninCreatePage from './pages/schedule/ScheduleSigninCreatePage'
import ScheduleDetailPage from './pages/schedule/ScheduleDetailPage'
import ScheduleMyListPage from './pages/schedule/ScheduleMyListPage'
import ScheduleRankPage from './pages/schedule/ScheduleRankPage'
import ResellCenterPage from './pages/resell/ResellCenterPage'
import ResellLiveroomPage from './pages/resell/ResellLiveroomPage'
import ResellRecruitPage from './pages/resell/ResellRecruitPage'
import WeikeDoor from './pages/WeikeDoor'
import ScheduleMyListSettingPage from './pages/schedule/ScheduleMyListSettingPage'
import SchedulePayPage from './pages/schedule/SchedulePayPage'
import SchedulePaySuccessPage from './pages/schedule/SchedulePaySuccessPage'
import ScheduleErrorPage from './pages/schedule/ScheduleErrorPage'
import CouponSPA from './pages/ActivityPage/Coupon/CouponSPA'
import CouponSPAApp from './pages/ActivityPage/Coupon/CouponSPAApp'
import LiveroomAppPage from './pages/liveroom/LiveroomAppPage'
import GiftCard from './pages/ActivityPage/GiftCard/GiftCard'
import GiftCardDetail from './pages/ActivityPage/GiftCard/GiftCardDetail'
import LectureCalendarPage from './pages/mywkPage/LectureCalendarPage'
import LectureCommentManagePage from './pages/recordedPage/CommentManagePage'
import ChannelEditExpectedLecturesPage from './pages/ChannelEdit/ChannelEditExpectedLecturesPage'
import AppApplyRecordPage from './pages/AppApplyRecordPage'
import AppTopUpPage from './pages/AppTopUpPage'
import ResellOrderPage from './pages/resell/ResellOrderPage'
import ResellLiveroomsPage from './pages/resell/ResellLiveroomsPage'
import Evaluation from './pages/BoughtPage/Evaluation'
import AppPage from './pages/AppPage'
import ChannelGroupBuyPage from './pages/channel/ChannelGroupBuyPage'
import LectureRegistrationPage from './pages/lecture/LectureRegistrationPage.js'
import SuperVipPage from './pages/SuperVipPage'
import SuperVipTransfer from './pages/SuperVipNewPage/SuperVipTransfer'
import TheSecond from './pages/ActivityPage/TheSecond/TheSecond'
import NewPeopleReports from  './pages/ActivityPage/NewPeopleReports/NewPeopleReports'
import NewPeopleTransfer from  './pages/ActivityPage/NewPeopleReports/NewPeopleTransfer'
import RefundPage from './pages/refund/refund'
import UserReviewsPage from "./pages/UserReviewsPage"
import PgyMallPay from "./pages/PgyMallPay"
import ResellAccountPage from './pages/resell/ResellAccountPage'
import NewIndexPage from './pages/NewIndexPage'

//lazy load
const DataCenter = (location, cb) => {
    require.ensure([], require => {
        cb(null, require('./pages/DataCenterPage').default);
    }, 'datacenter');
};

const LiveroomDataCenter = (location, cb) => {
    require.ensure([], require => {
        cb(null, require('./pages/LiveroomDataCenterPage').default);
    }, 'liveroomDatacenter');
};

const ActivityPage = (location, cb) => {
    require.ensure([], require => {
        cb(null, require('./pages/ActivityPage').default);
    }, 'activitypage');
};

const SuperVipActivityPages = (location,cb) => {
    require.ensure([], require => {
        cb(null, require('./pages/SuperVipNewPage/SuperVipActivityPages').default);
    }, 'supervipactivitypages');
}

function isTest() {
    return /(dbg.lizhiweike.com)|(localhost)/.test(window.location.host);
}

let browserHistoryMethod = browserHistory;

if (isTest()) {
    browserHistoryMethod = useRouterHistory(createHistory)({
        basename: '/2weikefe'
    })
}


const RouteConfig = (
    <Router history={browserHistoryMethod}>
        <Route path="/" component={Root}>
            <IndexRoute component={MainPage} />

            <Route path='/account/' component={AccountPage}/>
            <Route path='/account/bought' component={BoughtPage}/>
            <Route path='/account/bought/evaluation/:target_id' component={Evaluation}/>
            <Route path='/account/coupons' component={MyCouponListPage} />
            <Route path='/account/favourites' component={FavouriteRecordPage} />
            <Route path='/account/follows' component={FollowRecordPage} />
            <Route path='/account/customer_service' component={CustomerServicePage} />
            <Route path='/account/general' component={BoardGeneralPage} />
            <Route path='/account/setting' component={AccountSettingPage} />
            <Route path='/account/gift_card_accept/:type/:gift_card_accept_id/:sign' component={GiftCardAcceptPage}/>
            <Route path='/account/gift_card_detail/:type/:gift_card_detail_id' component={GiftCardDetailPage}/>
            <Route path='/account/gift_card_share/:type/:gift_card_share_id' component={GiftCardSharePage}/>
            <Route path='/account/lectures' component={JoinLectureListPage} />
            <Route path='/account/listened' component={BoughtPage}/>
            <Route path='/account/transaction_record_new' component={TransactionRecordPage}/>
            <Route path='/account/edit' component={ProfileEditPage} />
            <Route path='/account/edit/phone' component={PhoneEditPage} />

            <Route path='/channel/group_buy' component={ChannelGroupBuyPage}/>
            <Route path='/channel/:channel_id' component={ChannelPage}/>
            <Route path='/channel/:id/edit' component={ChannelEditPage}/>
            <Route path='/channel/:id/edit/title' component={ChannelEditTitlePage}/>
            <Route path='/channel/:id/edit/cover' component={ChannelEditCoverPage}/>
            <Route path='/channel/:id/edit/desc' component={ChannelEditDescPage}/>
            <Route path='/channel/:id/edit/pay' component={ChannelEditPayPage}/>
            <Route path='/channel/:id/edit/priority' component={ChannelEditPriorityPage}/>
            <Route path='/channel/:id/edit/limit' component={LectureEditLimitPage}/>
            <Route path='/channel/:id/edit/expected_lectures' component={ChannelEditExpectedLecturesPage}/>
            <Route path='/channel/:id/sharerank' component={ChannelShareRankPage}/>

            <Route path='/zhuanlan/:channel_id' component={ChannelPage}/>

            <Route path='/classroom/:lecture_id' component={ClassroomPage}/>

            <Route path='/complain/:type/:id' component={ComplainCategoryPage}/>
            <Route path='/complain/:type/:category/:id' component={ComplainReasonPage}/>

            <Route path='/lecture/schedule_pay' component={SchedulePayPage} />
            <Route path='/lecture/relay_confirm_new' component={RelayConfirmPage} />
            <Route path='/lecture/registration' component={LectureRegistrationPage}/>
            <Route path='/lecture/:lecture_id' component={LecturePageContainer}/>
            <Route path='/lecture/error/:type/:pageType' component={LectureErrorPage}/>
            <Route path='/lecture/:lecture_id/rewards' component={LectureRewardListPage}/>
            <Route path='/lecture/:lecture_id/sharerank' component={LectureShareRankPage}/>
            <Route path='/lecture/:lecture_id/comment_manage' component={LectureCommentManagePage}/>
            <Route path='/lecture/:id/edit' component={LectureEditPage}/>
            <Route path='/lecture/:id/edit/title' component={LectureEditTitlePage}/>
            <Route path='/lecture/:id/edit/cover' component={LectureEditCoverPage}/>
            <Route path='/lecture/:id/edit/desc' component={LectureEditDescPage}/>
            <Route path='/lecture/:id/edit/pay' component={LectureEditPayPage}/>
            <Route path='/lecture/:id/edit/time' component={LectureEditTimePage}/>
            <Route path='/lecture/:id/edit/channel' component={LectureEditChannelPage}/>
            <Route path='/lecture/:id/edit/mode' component={LectureEditModePage}/>
            <Route path='/lecture/:id/edit/reward' component={LectureEditRewardPage}/>
            <Route path='/lecture/:id/edit/limit' component={LectureEditLimitPage}/>
            <Route path='/lecture/:id/edit/priority' component={LectureEditPriorityPage}/>
            <Route path='/lecture/:id/edit/category' component={LectureEditCategoryPage}/>

            <Route path='/liveroom/create' component={LiveroomCreatePage}/>
            <Route path='/liveroom/create/guide' component={LiveroomCreateGuidePage}/>
            <Route path='/liveroom/vip' component={LiveroomVipPage}/>
            <Route path='/liveroom/:liveroom_id' component={LiveroomPage}/>
            <Route path='/liveroom/:liveroom_id/followers' component={LiveroomFollowersPage}/>
            <Route path='/liveroom/:liveroom_id/app' component={LiveroomAppPage}/>
            <Route path='/liveroom/:liveroom_id/refund' component={RefundPage}/>
            <Route path='/liveroom/:liveroom_id/comment' component={UserReviewsPage}/>
            <Route path='/liveroom/:liveroom_id/datacenter' getComponent={LiveroomDataCenter}/>
            <Route path='/liveroom/:liveroom_id/verify' component={LiveroomVerifyPage}/>
            <Route path='/liveroom/:liveroom_id/edit/viplist' component={LiveroomVipList}/>
            <Route path='/liveroom/:liveroom_id/edit/vip' component={LiveroomSettingVipPage}/>
            <Route path='/liveroom/:liveroom_id/edit/profile' component={LiveroomSettingProfilePage}/>
            <Route path='/liveroom/:liveroom_id/edit/main' component={liveroomlectuerrMain}/>
            <Route path="/liveroom/:liveroom_id/edit/ban" component={liveroomlecturerBan}/>
            <Route path='/liveroom/:liveroom_id/edit/manage' component={liverooomlectureManage}/>
            <Route path='/liveroom/:liveroom_id/edit/manage/invite' component={LiveroomLecturerManagerInvitePage}/>
            <Route path='/liveroom/:liveroom_id/edit/accept/invite' component={LiveroomLecturerAcceptInvitePage}/>
            <Route path='/liveroom/:liveroom_id/edit/:type' component={LiveroomSettingLecturesPage}/>
            <Route path='/liveroom/:liveroom_id/channel/create' component={ChannelCreatePage}/>
            <Route path='/liveroom/:liveroom_id/lecture/create' component={LectureCreateNewPage}/>
            <Route path='/liveroom/:liveroom_id/lecture/create_form' component={LectureCreateFormPage}/>

            <Route path='/liveroom/:liveroom_id/coupon/list' component={CouponListPage} />
            <Route path='/liveroom/:liveroom_id/coupon/:coupon_id/receiver/list' component={CouponViewPage} />
            <Route path='/liveroom/:liveroom_id/coupon/:coupon_id/share' component={CouponSharePage} />

            <Route path='/question' component={QuestionPage}/>
            <Route path='/question/category' component={QuestionCategory}/>
            <Route path='/question/category/:category_id' component={QuestionCategoryDetail}/>

            <Route path='/relay_setting/accept/:id' component={RelaySettingAcceptPage}/>
            <Route path='/relay_setting/share/:id' component={RelaySettingSharePage}/>
            <Route path='/relay_setting/:type/:id' component={RelaySettingPage}/>
            <Route path='/relay_setting/list/:type/:id' component={RelaySettingListPage}/>

            <Route path='/search' component={SearchPage}/>
            <Route path='/search/:type/detail' component={SearchDetailPage}/>

            <Route path='/specials/pgy_mall/pay' component={PgyMallPay} />
            <Route path='/specials/activity/:type' getComponent={ActivityPage}/>
            <Route path='/specials/app/:type' component={AppPage}/>
            <Route path='/specials/free'  component={FreeLecturePage} />
            <Route path='/specials/new/free' component={FreeLectureNewPage} />
            <Route path='/specials/freeCard' component={FreeLectureCard}/>
            <Route path='/specials/relay/:tab' component={RelaysPage} />
            <Route path='/specials/suggest' component={BestSubjectPage} />
            <Route path='/specials/__test' component={ConnectAppPage} />
            <Route path='/specials/mywk' component={MyNewWeiKePage}/>
            <Route path='/specials/mywk/calendar' component={LectureCalendarPage}/>
            <Route path='/specials/:channel_id/gift/receive' component={GiftReceiveSuccessPage}/>
            <Route path='/specials/feedback' component={FeedbackPage}/>
            <Route path='/specials/make_love' component={WeikeDoor}/>
            <Route path='/specials/coupon' component={CouponSPA}/>
            <Route path='/specials/coupon/app' component={CouponSPAApp}/>
            <Route path='/specials/giftcard' component={GiftCard}/>
            <Route path='/specials/giftcard/detail' component={GiftCardDetail}/>
            <Route path='/specials/second' component={TheSecond}/>
            <Route path='/specials/newreports' component={NewPeopleReports}/>
            <Route path='/specials/newreports_transfer' component={NewPeopleTransfer}/>

            {/* <Route path='/wallet' component={WalletPage} />
            <Route path='/wallet/transaction' component={WalletDetailPage} />
            <Route path='/wallet/iap_transaction' component={AppApplyRecordPage}/>
            <Route path='/wallet/iap_recharge' component={AppTopUpPage}/>
            <Route path='/wallet/withdraw_apply' component={WithdrawApplyPage}/>
            <Route path='/wallet/withdraw_apply_record' component={WithdrawApplyRecordPage}/> */}

            <Route path='/message/:tab' component={MessagePage} />
            <Route path='/message/chat/:receiverId' component={MessageChatPage} />
            <Route path='/message/info/:receiverId' component={MessageInfoPage} />

            <Route path='/schedule/my' component={ScheduleMyListPage} />
            <Route path='/schedule/my/setting' component={ScheduleMyListSettingPage} />
            <Route path='/schedule/:id/rank' component={ScheduleRankPage} />
            <Route path='/schedule/:id/calendar' component={ScheduleCalendarPage} />
            <Route path='/schedule/:id/signin/create' component={ScheduleSigninCreatePage} />
            <Route path='/schedule/:id' component={ScheduleDetailPage} />
            <Route path='/schedule/:id/pay_success' component={SchedulePaySuccessPage} />
            <Route path='/schedule/:id/error' component={ScheduleErrorPage} />

            <Route path='/resell' component={ResellCenterPage} />
            <Route path="/resell/account" component={ResellAccountPage} />
            <Route path='/resell/order' component={ResellOrderPage} />
            <Route path='/resell/liveroom' component={ResellLiveroomsPage} />
            <Route path='/resell/liveroom/:id/recruit' component={ResellRecruitPage} />
            <Route path='/resell/liveroom/:id' component={ResellLiveroomPage} />

            {/*↓type可选lecture、channel、liveroom*/}
            <Route path='/:type/:target_id/sharecard' component={ShareCardPage}/>
            {/*↓type可选lecture、channel、liveroom*/}
            <Route path='/:type/:id/analysis' getComponent={DataCenter}/>
            <Route path='/:type/:id/paylist' components={DataCenterPayListPage}/>
            <Route path='/:type/:id/listeners' components={ListenerManage}/>
            <Route path='/:type/:id/paysuccess' component={PaySuccessPage}/>
            <Route path='/:type/:target_id/invite' components={LecturerInvitePage}/>
            <Route path='/:type/:target_id/invite/card' components={LecturerInviteCardPage}/>

            <Route path='/supervip' components={SuperVipPage}/>
            <Route path='/supervipintro/:type' getComponent={SuperVipActivityPages} />
            <Route path='/supervipintro' components={SuperVipTransfer}/>
            <Route path='/supervipintro/sharecard/:type' components={ShareCardPage}/>

            <Route path='/specials/newindexpage' components={NewIndexPage}/>
        </Route>
    </Router>
);

export default RouteConfig;


// WEBPACK FOOTER //
// ./src/route.js